@if(discount > 0) {
<div class="b-radius-4 bg-col-1 center p-a-2 _reducePadding s2">
    @switch(mode) {
    @case('onAccountCreated') {
    <div class="s2">
        <span class="col-w">
            {{ 'Account Created' | translate }}
        </span>
        <span class="col-6">
            {{ 'you saved' | translate }}
            <price [value]="discount"></price>
        </span>
    </div>
    }
    @case('rrp') {
    <div class="s2">
        <span class="col-w">
            {{ 'RRP' | translate }} <price [value]="orgPrice"></price> - {{ 'YOU' | translate }}
        </span>
        <span class="col-6">
            {{ 'SAVE' | translate }}
            <price [value]="discount"></price>
            @if(!client.isL ) {
            ({{ discountPercent }}%)
            }
        </span>
    </div>
    }
    @case('offer') {
    <span class="col-w s3">
        <a class="link "
           [routerLink]="'/login/apply-for-account'">{{ 'Become a PGRPro' | translate}}</a>
    </span>
    <span class="col-6 p2">
        {{ 'and save' | translate }}
        <price [value]="discount"></price>
        @if(!client.isL) {
        ({{ discountPercent }}%)
        }
    </span>
    }
    }
</div>
}